<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-01-13 14:37:26
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\StaffCard\components\editStaffCard.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-27 17:08:29
-->
<template>
  <normalDialog
    :title="$t('label_essweb_StaffCard_list_dialog_cardConfigTitle')+'-'+$getCommonLangValue(curName)"
    :dialog="show"
    width="700"
    @close="closeDialog"
  >
    <template v-slot:content>
         <v-container class="d-flex pb-8" v-if="!isLoading&&triger==='edit'">
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              class="text-capitalize"
              color="primary"
              @click="addCard"
            >
              {{ $t("label_essweb_StaffCard_dialog_addCardBtnLabel") }}
              <span class="material-icons-round">add</span>
            </v-btn>
          </v-container>
        <noContent v-if="Data.length==0"/>
      <v-form ref="form" lazy-validation>
            <template v-for="(item,index) in  Data">
                     <v-row :key="`config--${index}`" class="pa-0 ma-0">
                         <v-col :md="triger==='edit'?5:6" class="py-0">
                             <v-sheet class="mrc_text_require text--secondary">{{
                    $t("label_essweb_StaffCard_dialog_cardCodeLabel")
                  }}</v-sheet>
               <v-text-field
                      single-line
              maxlength='50'
                        :readonly="triger==='view'"
                  :filled="triger==='edit'"
                  :disabled="triger==='edit'&&timeCompare(item.effective_utc_start_date_save)"
                      type="string"
                      :rules="$GetRules(['_Require_Rules'], [null])"
                      v-model="item.staff_card_code"
                      :placeholder="
                        $t('label_essweb_StaffCard_dialog_cardCodeLabel')
                      "
                      dense
                    ></v-text-field>
          </v-col>
                  <v-col :md="triger==='edit'?5:6" class="py-0">
                <DateTimePicker
                  type="date"
                  :disabled="triger==='edit'&&timeCompare(item.effective_utc_start_date_save)"
                  :readonly="triger==='view'"
                  :filled="triger==='edit'"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :defaultTime="item.effective_utc_start_date"
                  :label="
                    $t(
                      'label_essweb_StaffCard_dialog_startDateLabel'
                    )
                  "
                  placeholder="YYYY/MM/DD"
                  :refuseDate="refuseDate"
                  @change="(time) => (item.effective_utc_start_date = time)"
                ></DateTimePicker>
              </v-col>
          <v-col :md="triger==='edit'?1:0" class="d-flex align-center pt-0 pb-0 " v-if="triger==='edit'">
                <v-btn icon @click="onDelete(item)" v-if="!(item.uuid&&timeCompare(item.effective_utc_start_date_save))" :disabled="item.uuid&&timeCompare(item.effective_utc_start_date_save)">
                  <span class="material-icons-round">delete</span>
                </v-btn>
              </v-col>
                     </v-row>
            </template>
       </v-row></v-form
    ></template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closeDialog"  v-if="triger==='edit'"/>
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  name: "newFlowTemplatesMessage",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: null, type: [Number, String] },
    triger: { default: "edit", type: [Number, String] },
    curName: { default: null, type: [Number, String, Array, Object] },
  },
  computed: {
    ...mapGetters(["companyLang", "defaultUTC", "isLoading"]),
    refuseDate() {
      return [];
    },
  },
  watch: {
    show(val) {
      this.deleteUuids = [];
      if (!val) {
        this.Data = [];
      }
    },
    curUuid(val) {
      this.deleteUuids = [];
      if (val) this.getDetail(val);
    },
  },
  data() {
    return {
      iSEdited: true,
      deleteUuids: [],
      Data: [],
    };
  },
  mounted() {},
  methods: {
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_map_staff_punch_card_number",
        url: "/staff-card/get-details/",
        data: { staff_uuid: uuid },
        global: false,
      }).then((res) => {
        res.data.map((item) => {
          item["actionid"] = new Date().getTime() + "" + Math.random() * 100000;
          item["effective_utc_start_date"] = that.$getDateTime(
            item.effective_utc_start_date,
            "YYYY-MM-DD"
          );
          item["effective_utc_start_date_save"] = that.$getDateTime(
            item.effective_utc_start_date,
            "YYYY-MM-DD"
          );
        });
        that.Data = res.data;
      });
    },
    timeCompare(time) {
      if (!time) return false;
      if (this.$getTimeValue(time) > new Date().getTime()) {
        return false;
      }
      return true;
    },
    addCard: function () {
      // 改为增加到前面 mel bug1506
      this.Data.unshift({
        uuid: null,
        actionid: new Date().getTime(),
        staff_uuid: this.curUuid,
        staff_card_code: "",
        effective_utc_start_date: "",
        effective_utc_start_date_save: "",
        effective_start_time_zone: this.defaultUTC,
        remarks: "",
        source: "",
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    onDelete: function (item) {
      if (item["uuid"]) {
        this.deleteUuids.push(item.uuid);
      }
      this.Data = this.Data.filter((ele) => ele.actionid !== item.actionid);
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("save", this.Data, this.deleteUuids);
    },
  },
};
</script>